<p-dialog 
  [header]="dialogHeader" 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  styleClass="chart-dialog"
  [style]="{width: '90vw', height: '80vh', 'max-width': '1200px'}"
  [transitionOptions]="'150ms cubic-bezier(0.25, 0.8, 0.25, 1)'"
  (onShow)="onShow()"
  (onHide)="onHide()"
  (onMaximize)="onMaximize()"
  (onUnmaximize)="onUnmaximize()">
  
  <div class="chart-container" [class.fullscreen-mode]="isMaximized">
    <div class="chart-header">
      <h3>
        <i class="pi" [ngClass]="chartIcon"></i>
        Cumulative Order {{ chartType === 'revenue' ? 'Values' : 'Numbers' }} Analysis
      </h3>
      <p>Cumulative {{ chartType === 'revenue' ? 'Values' : 'Numbers' }} progression by customer for {{ selectedYear }}</p>
    </div>
    
    <!-- Chart container with responsive dimensions -->
    <div class="chart-canvas-container" [class.fullscreen-chart]="isMaximized">
      
      <!-- Loading indicator -->
      <div *ngIf="isChartLoading" class="chart-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <p>Loading chart...</p>
      </div>

      <!-- No data message -->
      <div *ngIf="!isChartLoading && !hasValidData" class="no-data-message">
        <i class="pi pi-info-circle"></i>
        <h4>No Data Available</h4>
        <p>No {{ chartType === 'revenue' ? 'revenue' : 'quantity' }} data found for the selected period.</p>
      </div>
      
      <!-- Chart canvas with responsive sizing -->
      <canvas #chartCanvas 
              class="chart-canvas"
              [style.display]="showCanvas && hasValidData ? 'block' : 'none'"
              [attr.width]="canvasWidth"
              [attr.height]="canvasHeight">
      </canvas>
    </div>
    
    <div class="chart-footer">
      <div class="chart-stats">
        <div class="stat-item">
          <i class="pi pi-users"></i>
          <span>{{ customerCount }} Customer{{ customerCount !== 1 ? 's' : '' }}</span>
        </div>
        <div class="stat-item">
          <i class="pi pi-calendar"></i>
          <span>{{ monthCount }} Month{{ monthCount !== 1 ? 's' : '' }}</span>
        </div>
        <div class="stat-item">
          <i class="pi" [ngClass]="chartType === 'revenue' ? 'pi-dollar' : 'pi-box'"></i>
          <span>{{ totalDisplayValue }} {{ totalLabel }}</span>
        </div>
        <div class="stat-item data-indicator">
          <i class="pi pi-database"></i>
          <span>Live Data</span>
        </div>
        <div class="stat-item fullscreen-indicator" *ngIf="isMaximized">
          <i class="pi pi-window-maximize"></i>
          <span>Fullscreen Mode</span>
        </div>
      </div>
      <div class="chart-actions">
        <p-button 
          label="Export Chart" 
          icon="pi pi-download" 
          styleClass="p-button-outlined p-button-sm"
          [disabled]="!hasValidData"
          (onClick)="onExportChart()">
        </p-button>
        <p-button 
          label="Close" 
          icon="pi pi-times" 
          styleClass="p-button-secondary p-button-sm"
          (onClick)="onCloseChart()">
        </p-button>
      </div>
    </div>
  </div>
</p-dialog>
